/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';
import { dashcamOrigin } from '@/utils/environments';

export function DriftReportsPage() {
  const selectedTenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);
  const origin = dashcamOrigin();
  if (!origin) return null;
  const reportSource = `${origin}/drift-report-beta?tenant_id=${encodeURIComponent(selectedTenantID ?? '')}`;

  return (
    <iframe
      title="Drift Reports"
      style={{
        width: '100%',
        flex: 1,
        border: 'none',
      }}
      src={reportSource}
    />
  );
}
